import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/utils';
import { MarkdownText } from '@/shared/components';

interface InternalTransferInfoMessageProps {
  translationKey: string;
  linkAction: string;
  linkTarget: string;
  className?: string;
}

export function InternalTransferInfoMessage({
  translationKey,
  linkAction,
  linkTarget,
  className,
}: InternalTransferInfoMessageProps) {
  const { t } = useTranslation();

  const handleLinkClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (linkAction === 'navigate') {
      window.location.href = linkTarget;
    } else if (linkAction === 'external') {
      window.open(linkTarget, '_blank', 'noopener,noreferrer');
    }
  };

  const message = t(translationKey).replace(/\{link\}/g, linkTarget);

  return (
    <div
      className={cn(
        'w-full px-[1.6rem] py-[1.2rem] bg-muted rounded-[1.2rem]',
        className
      )}>
      <MarkdownText
        variant="default"
        className="w-full"
        components={{
          p: ({ children, ...props }) => (
            <p {...props} className="p4 text-secondary">
              {children}
            </p>
          ),
          a: ({ href, children, ...props }) => {
            if (href === linkTarget) {
              return (
                <button
                  type="button"
                  onClick={handleLinkClick}
                  className="p4 text-primary hover:underline cursor-pointer inline pointer-events-auto">
                  {children}
                </button>
              );
            }
            return (
              <a
                {...props}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="p4 text-primary hover:underline pointer-events-auto">
                {children}
              </a>
            );
          },
        }}>
        {message}
      </MarkdownText>
    </div>
  );
}
